import styles from "@/components/ChartLegend.module.css";

interface ChartLegendItem {
  color: string;
  label: string;
  value?: string;
}

interface ChartLegendProps {
  items: ChartLegendItem[];
  twoColumns?: boolean;
}

const ChartLegend = ({ items, twoColumns = false }: ChartLegendProps) => (
  <ul
    className={
      twoColumns ? `${styles.legend} ${styles.twoColumns}` : styles.legend
    }
    data-columns={twoColumns ? 2 : 1}
  >
    {items.map(({ color, label, value }) => (
      <li key={`${label}-${color}`} className={styles.item}>
        <span className={styles.swatch} style={{ backgroundColor: color }} />
        <span className={styles.label}>{label}</span>
        {value !== undefined && <span className={styles.value}>{value}</span>}
      </li>
    ))}
  </ul>
);

export default ChartLegend;
